const GLOBAL_BASE_TEST_ID = 'ai-filter-context-global';
const LOCAL_BASE_TEST_ID = 'ai-filter-context-local';

export const TestIds = {
  container: 'ai-filter-context',
  accordion: 'ai-filter-context-accordion',
  global: GLOBAL_BASE_TEST_ID,
  globalGroup: `${GLOBAL_BASE_TEST_ID}-group`,
  globalLabel: `${GLOBAL_BASE_TEST_ID}-label`,
  globalChips: `${GLOBAL_BASE_TEST_ID}-chips`,
  globalToggle: `${GLOBAL_BASE_TEST_ID}-toggle`,
  local: LOCAL_BASE_TEST_ID,
  localGroup: `${LOCAL_BASE_TEST_ID}-group`,
  localLabel: `${LOCAL_BASE_TEST_ID}-label`,
  localChips: `${LOCAL_BASE_TEST_ID}-chips`,
  localToggle: `${LOCAL_BASE_TEST_ID}-toggle`,
};
